<div *ngIf="saving">
	<div class="flex align-items-center justify-content-center w-full pb-8 mb-8">
		<p-progressSpinner ariaLabel="loading"></p-progressSpinner>
	</div>
</div>

<div *ngIf="!saving">
	<div class="grid" *ngIf="!enabledLog">
		<div class="col-12 flex align-items-center justify-content-center bg-yellow-200 p-1 border-round-xl">
			<div class="flex align-items-center justify-content-center flex-wrap gap-1">
				<p-tag icon="pi cm-alert" [value]="('LOGS_NOT_ENABLE_NOW' | translate)" severity="warning"></p-tag>
				<p-button *ngIf="online && configured" styleClass="border-0" icon="pi cm-events" size="large" label="{{ 'ENABLE_LOG' | translate }}"
					(click)="enableAccessLog()" [rounded]="false" [text]="true" severity="secondary" >
				</p-button>
			</div>
		</div>
	</div>
	<form [formGroup]="accessFilterGroup">
		<div class="grid mt-0 px-3">
			<div [class]="col4Responsive()">
				<div class="flex justify-content-between flex-wrap border-bottom-1 border-900"
					[ngClass]="simpleInputTextLayout('borderRow')">
					<div class="flex align-items-center justify-content-center" [ngClass]="simpleInputTextLayout('label')">
						{{'START_DATE_TIME' | translate }}</div>
					<div class="flex align-items-center justify-content-center"
						[ngClass]="simpleInputTextLayout('borderInput')">
						<p-calendar [showIcon]="true" formControlName="startDateTime" [showButtonBar]="true"
							placeholder="{{'START_DATE_TIME' | translate}}" id="access-log-startTime-filter"
							[ngClass]="dynamicInputTextWidth()" styleClass="{{ dynamicInputTextWidth() }}"
							inputStyleClass="pl-6 border-noround-right surface-900" [minDate]="minDate" [maxDate]="maxDate"
							[defaultDate]="today" [showTime]="true" [hourFormat]="24">
						</p-calendar>
					</div>
				</div>
			</div>
			<div [class]="col4Responsive()">
				<div class="flex justify-content-between flex-wrap border-bottom-1 border-900"
					[ngClass]="simpleInputTextLayout('borderRow')">
					<div class="flex align-items-center justify-content-center" [ngClass]="simpleInputTextLayout('label')">
						{{'END_DATE_TIME' | translate }}</div>
					<div class="flex align-items-center justify-content-center"
						[ngClass]="simpleInputTextLayout('borderInput')">
						<p-calendar [showIcon]="true" formControlName="endDateTime" [showButtonBar]="true"
							placeholder="{{'END_DATE_TIME' | translate}}" id="access-log-endTime-filter"
							[ngClass]="dynamicInputTextWidth()" styleClass="{{ dynamicInputTextWidth() }}"
							inputStyleClass="pl-6 border-noround-right surface-900" [minDate]="minDate" [defaultDate]="today"
							[maxDate]="maxDate" [showTime]="true" [hourFormat]="24">
						</p-calendar>
					</div>
				</div>
			</div>
			<div [class]="col4Responsive()">
				<div class="flex justify-content-between flex-wrap border-bottom-1 border-900"
					[ngClass]="simpleInputTextLayout('borderRow')">
					<div class="flex align-items-center justify-content-center" [ngClass]="simpleInputTextLayout('label')">
						{{'USER' | translate }}</div>
					<div class="flex align-items-center justify-content-center"
						[ngClass]="simpleInputTextLayout('borderInput')">
						<span class="p-input-icon-left" [class]="dynamicInputTextWidth()">
							<i class="pi cm-search"></i>
							<input formControlName="searchFilter" pInputText type="text" [ngClass]="dynamicInputTextWidth()"
								class="pr-6" id="access-log-search-filter" placeholder="{{ 'SEARCH' | translate }}"
								maxlength="254" class="surface-900"/>
						</span>
					</div>
				</div>
			</div>
			<div [class]="col4Responsive()">
				<div class="flex justify-content-between flex-wrap border-bottom-1 border-900"
					[ngClass]="simpleInputTextLayout('borderRow')">
					<div class="flex align-items-center justify-content-center" [ngClass]="simpleInputTextLayout('label')">{{
						'COMMAND_DEVICE' | translate }}</div>
					<div class="flex align-items-center justify-content-center"
						[ngClass]="simpleInputTextLayout('borderInput')">
						<p-dropdown [options]="accessType" formControlName="type" [ngClass]="dynamicInputTextWidth()"
							styleClass="{{ dynamicInputTextWidth() }} align-items-center pl-5 surface-900" id="events-input-deviceFilter"
							placeholder="{{ 'SELECT_ACCESS_TYPE' | translate }}">
							<ng-template let-item pTemplate="selectedItem">
								<div class="item flex align-items-center justify-content-center">
									<div class="flex align-items-center">{{ item.label | translate }}</div>
								</div>
							</ng-template>
							<ng-template let-section pTemplate="item">
								<div class="item flex justify-content-center">
									<div>{{section.label | translate }}</div>
								</div>
							</ng-template>
						</p-dropdown>
					</div>
				</div>
			</div>
			<div [class]="col4Responsive()">
				<div class="flex justify-content-between flex-wrap border-bottom-1 border-900"
					[ngClass]="simpleInputTextLayout('borderRow')">
					<div class="flex align-items-center justify-content-center" [ngClass]="simpleInputTextLayout('label')">
						{{'EVENTS' | translate }}</div>
					<div class="flex align-items-center justify-content-center"
						[ngClass]="simpleInputTextLayout('borderInput')">
						<p-dropdown [options]="accessResult" formControlName="result" [ngClass]="dynamicInputTextWidth()"
							styleClass="{{ dynamicInputTextWidth() }} align-items-center pl-5 surface-900" id="access-log-result-filter"
							[panelStyleClass]="dynamicAutocomplete()" placeholder="{{ 'SELECT_RESULT' | translate }}">
							<ng-template let-item pTemplate="selectedItem">
								<div class="item flex align-items-center justify-content-center">
									<div class="flex align-items-center">{{ item.label | translate }}</div>
								</div>
							</ng-template>
							<ng-template let-section pTemplate="item">
								<div class="item flex align-items-center justify-content-center">
									<div>{{section.label | translate }}</div>
								</div>
							</ng-template>
						</p-dropdown>
					</div>
				</div>
			</div>
			<div *ngIf="!onExtendedMobile()" [class]="underTablet() ? 'col-6' : col2Responsive()">
				<div class="flex justify-content-center">
					<p-button icon="pi cm-reload" label="{{ 'REFRESH' | translate }}" (click)="refresh()"
						[rounded]="false" [text]="true" severity="primary" styleClass="font-bold border-primary surface-900 hover:bg-blue-900 w-17rem">
					</p-button>
				</div>
			</div>
			<div *ngIf="!onExtendedMobile()" [class]="underTablet() ? 'col-6' : col2Responsive()">
				<div class="flex justify-content-center">
					<p-button icon="pi cm-download" label="{{ 'EXPORT' | translate }}" (click)="exportToCsv()"
						[disabled]="logs.length<=0"
						[rounded]="false" [text]="true" severity="primary" styleClass="font-bold border-primary surface-900 hover:bg-blue-900 w-17rem">
					</p-button>
				</div>
			</div>
			<div *ngIf="onExtendedMobile()" class="col-12">
					<p-button icon="pi cm-reload" label="{{ 'REFRESH' | translate }}" (click)="refresh()"
						[rounded]="false" [text]="true" severity="primary" styleClass="font-bold border-primary surface-900 hover:bg-blue-900 w-full pr-5">
					</p-button>
			</div>
			<div *ngIf="onExtendedMobile()" class="col-12">
					<p-button icon="pi cm-download" label="{{ 'EXPORT' | translate }}" (click)="exportToCsv()"
						[disabled]="logs.length<=0"
						[rounded]="false" [text]="true" severity="primary" styleClass="font-bold border-primary surface-900 hover:bg-blue-900 w-full pr-5">
					</p-button>
			</div>
		</div>
	</form>

	<div class="grid mt-0">
		<div class="col-12">
			<div class="card border-round">
				<p-table #tableMtmaLogAccessList dataKey="Id" [value]="logs" [totalRecords]="resultLength" [rows]="pageSize"
					[loading]="logsLoading" [paginator]="true" [lazy]="true" (onLazyLoad)="loadLogs($event)" [showCurrentPageReport]="true"
					currentPageReportTemplate="{{ 'TABLE_REPORT' | translate }}" [autoLayout]="true" sortField="EventDate"
					[sortOrder]="-1" responsiveLayout="stack">
					<ng-template pTemplate="header">
						<tr>
							<th style="width: 5rem"></th>
							<th>
								<div pSortableColumn="EventDate" class="flex align-items-center justify-content-center">
									{{ 'EVENT_DATE' | translate }}
									<p-sortIcon field="EventDate"></p-sortIcon>
								</div>
							</th>
							<th>
								<div class="flex align-items-center justify-content-center">
									{{ 'USER' | translate }}
								</div>
							</th>
							<th>
								<div class="flex align-items-center justify-content-center">
									{{ 'COMMAND_DEVICE' | translate }}
								</div>
							</th>
							<th>
								<div pSortableColumn="Result" class="flex align-items-center justify-content-center">
									{{ 'LOG_RESULT' | translate }}
									<p-sortIcon field="Result"></p-sortIcon>
								</div>
							</th>
						</tr>
					</ng-template>
					<ng-template pTemplate="body" let-row let-expanded="expanded">
						<tr>
							<td>
								<p-button *ngIf="getActionEventLenght(row.ActionEvents)"
									styleClass="surface-900 hover:bg-primary border-1 border-600" [pRowToggler]="row"
									[rounded]="true" [icon]="expanded ? 'pi cm-angle-down' : 'pi cm-angle-right'" />
							</td>
							<td>
								<span class="p-column-title font-semibold">{{ 'EVENT_DATE' | translate }}</span>{{ row.EventDate |
								localizedDate: 'medium':'UTC' }}
							</td>
							<td>
								<span class="p-column-title font-semibold">{{ 'USER' | translate }}</span>{{ userData(row) }}
							</td>
							<td>
								<span class="p-column-title font-semibold">{{ 'COMMAND_DEVICE' | translate }}</span>{{
								passageData(row) }}
							</td>
							<td>
								<span class="p-column-title font-semibold">{{ 'LOG_RESULT' | translate }}</span>
								<p-tag *ngIf="row.Result === 1" value="{{ getResult(row.Result) }}" severity="success"></p-tag>
								<p-tag *ngIf="row.Result === 2 || row.Result === 3 || row.Result === 4"
									value="{{ getResult(row.Result) }}" severity="danger"></p-tag>
							</td>
						</tr>
					</ng-template>
					<ng-template pTemplate="emptymessage">
						<tr>
							<td colspan="7">{{ 'TABLE_NO_ELEMENT' | translate }}</td>
						</tr>
					</ng-template>
					<ng-template pTemplate="rowexpansion" let-accessEvent>
						<tr class="surface-400">
							<td colspan="6">
								<div class="w-full" [class]="onExtendedMobile() ? 'px-2' : 'px-6'">
									<p-table [value]="accessEvent.ActionEvents" [paginator]="false" [showCurrentPageReport]="true"
										currentPageReportTemplate="{{ 'TABLE_REPORT' | translate }}" [autoLayout]="true"
										responsiveLayout="stack">
										<ng-template *ngIf="getActionEventLenght(accessEvent.ActionEvents)" pTemplate="header">
											<tr>
												<th>
													<div class="flex align-items-center justify-content-center">
														{{ 'EVENT_DATE' | translate }}
													</div>
												</th>
												<th>
													<div class="flex align-items-center justify-content-center">
														{{ 'AUTOMATION' | translate }}
													</div>
												</th>
												<th>
													<div class="flex align-items-center justify-content-center">
														{{ 'EXECUTION_STATE' | translate }}
													</div>
												</th>
											</tr>
										</ng-template>
										<ng-template pTemplate="body" let-actionEvents>
											<tr>
												<td>
													<span class="p-column-title font-semibold">{{ 'EVENT_DATE' | translate }}</span>{{
													getDate(actionEvents.EventDate) | localizedDate: 'medium':'UTC' }}
												</td>
												<td>
													<span class="p-column-title font-semibold">{{ 'AUTOMATION' | translate }}</span>{{
													getAutomationName(actionEvents)}}
												</td>
												<td>
													<span class="p-column-title font-semibold">{{ 'EXECUTION_STATE' | translate }}</span>
													<p-tag *ngIf="getActionResultColor(actionEvents.Result) !== ''"
														[value]="getActionResultInfo(actionEvents.Result)"
														[severity]="getActionResultColor(actionEvents.Result)"></p-tag>
												</td>
											</tr>
										</ng-template>
										<ng-template pTemplate="emptymessage">
											<tr>
												<td colspan="7" [class]="underTablet() ? 'flex justify-content-center' : ''">{{ 'TABLE_NO_ELEMENT' |
													translate }}</td>
											</tr>
										</ng-template>
									</p-table>
								</div>
							</td>
						</tr>
					</ng-template>
				</p-table>
			</div>
		</div>
	</div>
</div>

<p-confirmDialog #confDialog>
	<ng-template pTemplate="footer">
		<div class="col-12 flex justify-content-center">
			<button type="button" pButton [label]="confDialog.acceptButtonLabel" [ngClass]="acceptButtonStyle"
				(click)="confDialog.accept()">
			</button>
			<button type="button" pButton *ngIf="rejectButtonVisible" [label]="confDialog.rejectButtonLabel"
				[ngClass]="rejectButtonStyle" (click)="confDialog.reject()">
			</button>
		</div>
	</ng-template>
</p-confirmDialog>